// eslint-disable-next-line no-unused-vars
import { numeral } from '@fund/basic-lib';
import tools from '@fund/data';
import { market as config } from '../config';
import p from './public';
// 格式化'%'时不自动除100
numeral.options.scalePercentBy100 = false;

// 市场行情（走势图）- 单位净值
export default {

  // 格式化数据
  formatData: (row, buyAndSellPointData, timeCode) => {
    let data = [];
    const rowData = row;

    // 数据缺值测试
    // const testIndex = 2;
    // delete rowData.Datas[testIndex].DWJZ;
    // delete rowData.Datas[testIndex].JZZZL;
    let ctimeName = '';
    if (timeCode === '5n') {
      ctimeName = '近5年';
    }
    if (timeCode === 'ln') {
      ctimeName = '成立来';
    }
    rowData.Datas = p().configureBuyAndRealData(row, buyAndSellPointData, ctimeName, 'FSRQ');
    // eslint-disable-next-line array-callback-return
    rowData.Datas.map(({ FSRQ, DWJZ, JZZZL }, index) => {
      let fData = {
        date: FSRQ,
        type: '单位净值',
        value: p().getDataWhenEmpty(rowData.Datas, index, 'DWJZ') - 0,
        rise: p().getDataWhenEmpty(rowData.Datas, index, 'JZZZL') - 0,
        real_value: tools.noData(DWJZ),
        real_rise: tools.noData(JZZZL),
        index,
        max: rowData.Datas.length,
      };

      // 获取极坐标数据
      fData = p().formatPolarPoint(fData, index, rowData, 'FSRQ');

      if (timeCode === '5n' || timeCode === 'ln') {
        let nextdate = '';
        if (rowData.Datas.length > (index + 1)) {
          nextdate = rowData.Datas[index + 1].FSRQ;
        }
        // 设置买卖点
        fData = p().setBuyAndSalePoint(fData, buyAndSellPointData, true, nextdate);
      } else {
        // 设置买卖点
        fData = p().setBuyAndSalePoint(fData, buyAndSellPointData, false, '');
      }

      // 设置变动点
      fData = p().setChangedPointNew(fData, rowData);

      data = data.concat([fData]);
    });

    return data;
  },

  // 绘制走势图
  drawChart(data, chart, alertTips, changeSlideState, unitPrice, showUnitPrice,
    isReDrawing, setLegend, isbigChart) {
    // 创建十字线组件
    const {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    } = p().createToolTipsList(chart);
    const toolTipsList = {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    };

    // 绘制走势图
    chart.source(data, p().sourceConfig);

    // 水印
    p().drawLogo(chart);
    if (isbigChart) {
      chart.scale('value', {
        nice: true,
        max: p().getMaxVal(data) * 1.01,
      });
    } else {
      chart.scale('value', {
        nice: true,
        max: p().getMaxVal(data),
      });
    }
    chart.legend(false);

    chart.tooltip({
      ...p().tooltipConfig,
      yTip(val) {
        return {
          ...p().yTipsConfig,
          text: numeral(val).format('0.0000', Math.trunc),
        };
      },
      onChange: (obj) => {
        p().tooltipOnChange();
        changeSlideState(true);

        const point = obj.items[0].origin;
        setLegend([
          point.date, // 0 日期
          point.real_value, // 1 单位净值
          point.real_rise, // 2 涨幅
        ]);
        // 显示十字线
        p().showToolTips(toolTipsList, obj.items[0], (val) => numeral(val).format('0.0000', Math.trunc));
      },
      onHide: () => {
        p().tooltipOnHide();
        changeSlideState(false);
        // 隐藏十字线
        p().hideToolTIps(toolTipsList);
      },
    });

    chart.axis('value', {
      ...p().yAxisGridConfig,
      label: function label(text) {
        const cfg = {
          ...p().yAxisConfig,
          text: numeral(text).format('0.0000', Math.trunc),
        };
        return cfg;
      },
    });

    chart.axis('date', {
      ...p().xAxisGridConfig,
      label: function label(text, index, total) {
        let textCfg = {
          text: text.substring(5),
        };
        if (index === 0) {
          textCfg.textAlign = 'left';
        } else if (index === total - 1) {
          textCfg.textAlign = 'right';
        } else {
          textCfg = null;
        }
        return textCfg && { ...p().xAxisConfig, ...textCfg };
      },
    });

    // 设置极点提示
    p().drawPolarTips(data, chart, 'dateType:price');

    // 画摊薄成本线
    if (unitPrice !== null && showUnitPrice) {
      chart.guide().line({
        start: ['min', unitPrice],
        end: ['max', unitPrice],
        style: {
          stroke: '#f40', // 线的颜色
          lineDash: [0, 2, 2], // 虚线的设置
          lineWidth: 1, // 线的宽度
        },
        limitInPlot: true,
      });
    }

    chart.line({ connectNulls: true }).position('date*value').color('type', config.colors).size(2)
      .animate(false);

    // 画买卖点
    p().drawTradeMarker(data, chart);

    // 画变动点
    p().drawChangedMarker(data, chart, alertTips);
    // 画分红点
    p().drawChangedFHMarker(chart);

    chart.render();
  },
};
